// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Kp5MF {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  height: 100%;
}

.VHtmfD {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.VUUSz2 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  margin: 0;
  width: 685px;
  height: 25px;
}

.UFmH4S {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 331px;
  height: auto;
}

.bmya3a {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  width: 100%;
  height: 21px;
}

.vspCSj {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.424;
  color: #1f1f1f;
  width: auto;
  height: auto;
}

.gcz6DQ {
  height: 1px;
  background-color: #e6e6e6;
  width: 100%;
}

.nNpu4q {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  height: auto;
}

.T31j1z {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 331px;
}

.sS0AEm {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.OHTXSp {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.HCfSRD {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 331px;
  height: auto;
}

.gxNc_m {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.n_XeHa {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-1);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
}

.fEmFEe {
  width: 16px;
  height: 16px;
  color: #d64000;
}

.sSCM8a {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
  width: 100%;
  max-width: 685px;
}

.bhby_u {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.d9b7I2 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.6;
  color: #666666;
  text-align: left;
}

.d02aES {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  height: auto;
}

.HEx6R2 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 331px;
  height: auto;
}

.DayH6z {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.QhUTqM {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.Lw4F1n {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.eEklAF {
  font-weight: 400;
  color: #666666;
}

.miOeeS {
  font-weight: 600;
  color: #1f1f1f;
}

.AfTl7r {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 331px;
  height: auto;
}

.XX4FxX {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.RaVerR {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.xmuP4D {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.F2QOHN {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  gap: 12px;
  padding: 15px 0 0 0;
  background-color: #ffffff;
}

.yxzCq6 {
  min-width: 100px;
}

.TszVwB {
  min-width: 100px;
}

.lPPIvL {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #1f1f1f;
}

.ZCLItt {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--brand-tr-orange);
}

.gIsqRi {
  top: 100% !important;
  bottom: auto !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixTransferRevision/PixTransferRevision.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n}\n\n.content {\n  flex: 1;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.title {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  margin: 0;\n  width: 685px;\n  height: 25px;\n}\n\n.valueSection {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 331px;\n  height: auto;\n}\n\n.valueLabel {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  width: 100%;\n  height: 21px;\n}\n\n.valueAmount {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.424;\n  color: #1f1f1f;\n  width: auto;\n  height: auto;\n}\n\n.divider {\n  height: 1px;\n  background-color: #e6e6e6;\n  width: 100%;\n}\n\n.transactionDetails {\n  display: flex;\n  flex-direction: row;\n  align-self: stretch;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n  height: auto;\n}\n\n.transactionInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 331px;\n}\n\n.transactionLabel {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.transactionValue {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.paymentDateInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 331px;\n  height: auto;\n}\n\n.paymentDateLabel {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.paymentDateButton {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--spacing-1);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.calendarIcon {\n  width: 16px;\n  height: 16px;\n  color: #d64000;\n}\n\n.contactSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 8px;\n  width: 100%;\n  max-width: 685px;\n}\n\n.addContactCheckbox {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.contactHelperText {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #666666;\n  text-align: left;\n}\n\n.accountDetails {\n  display: flex;\n  flex-direction: row;\n  align-self: stretch;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n  height: auto;\n}\n\n.originInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 331px;\n  height: auto;\n}\n\n.originLabel {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.originDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.originText {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.fieldLabel {\n  font-weight: 400;\n  color: #666666;\n}\n\n.fieldValue {\n  font-weight: 600;\n  color: #1f1f1f;\n}\n\n.destinationInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 331px;\n  height: auto;\n}\n\n.destinationLabel {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.destinationDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.destinationText {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n  gap: 12px;\n  padding: 15px 0 0 0;\n  background-color: #ffffff;\n}\n\n.backButton {\n  min-width: 100px;\n}\n\n.confirmButton {\n  min-width: 100px;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #1f1f1f;\n}\n\n.mediumRegularOrangeText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--brand-tr-orange);\n}\n\n.placementBottom {\n  top: 100% !important;\n  bottom: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_Kp5MF`,
	"content": `VHtmfD`,
	"title": `VUUSz2`,
	"valueSection": `UFmH4S`,
	"valueLabel": `bmya3a`,
	"valueAmount": `vspCSj`,
	"divider": `gcz6DQ`,
	"transactionDetails": `nNpu4q`,
	"transactionInfo": `T31j1z`,
	"transactionLabel": `sS0AEm`,
	"transactionValue": `OHTXSp`,
	"paymentDateInfo": `HCfSRD`,
	"paymentDateLabel": `gxNc_m`,
	"paymentDateButton": `n_XeHa`,
	"calendarIcon": `fEmFEe`,
	"contactSection": `sSCM8a`,
	"addContactCheckbox": `bhby_u`,
	"contactHelperText": `d9b7I2`,
	"accountDetails": `d02aES`,
	"originInfo": `HEx6R2`,
	"originLabel": `DayH6z`,
	"originDetails": `QhUTqM`,
	"originText": `Lw4F1n`,
	"fieldLabel": `eEklAF`,
	"fieldValue": `miOeeS`,
	"destinationInfo": `AfTl7r`,
	"destinationLabel": `XX4FxX`,
	"destinationDetails": `RaVerR`,
	"destinationText": `xmuP4D`,
	"footer": `F2QOHN`,
	"backButton": `yxzCq6`,
	"confirmButton": `TszVwB`,
	"loading": `lPPIvL`,
	"mediumRegularOrangeText": `ZCLItt`,
	"placementBottom": `gIsqRi`
};
module.exports = ___CSS_LOADER_EXPORT___;
